import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { USER_API } from '../common/common';
import { postApi, notifyError } from '../service';
import { Logout } from '../common/Funcation';
import Cookies from 'universal-cookie';
import { isMobile } from 'react-device-detect';

const DraggablePromo = () => {
  const location = useLocation()
  const cookies = new Cookies()
  const buttonRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState(null);

  const offset = useRef({
    x: 0,
    y: 0,
  });

  // Only show on "/" and "/sports" routes
  const shouldShow = location.pathname === '/' || location.pathname === '/sports';

  const handlePointerDown = (e) => {
    if (!buttonRef.current) return;

    const rect = buttonRef.current.getBoundingClientRect();

    offset.current = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };

    e.currentTarget.setPointerCapture(e.pointerId);

    setIsDragging(true);
  };

  const handlePointerMove = (e) => {
    if (!isDragging || !buttonRef.current) return;

    const rect = buttonRef.current.getBoundingClientRect();

    // 5% boundary
    const marginX = window.innerWidth * 0.02;
    const marginY = window.innerHeight * 0.01;

    let newX = e.clientX - offset.current.x;
    let newY = e.clientY - offset.current.y;

    // Horizontal limits
    const minX = marginX;
    const maxX = window.innerWidth - rect.width - marginX;

    // Vertical limits
    const minY = marginY;
    const maxY = window.innerHeight - rect.height - marginY;

    // Clamp position
    newX = Math.max(minX, Math.min(newX, maxX));
    newY = Math.max(minY, Math.min(newY, maxY));

    setPosition({
      x: newX,
      y: newY,
    });
  };

  const handlePointerUp = (e) => {
    setIsDragging(false);

    if (e.currentTarget.hasPointerCapture(e.pointerId)) {
      e.currentTarget.releasePointerCapture(e.pointerId);
    }
  };

  const getCasinoLink = async (fromMobile = false) => {
    if (cookies.get('skyTokenFront')) {
      let data = {
        api: USER_API.CASINO_LOGIN,
        value: {
          id: 'loginType',
          isMobileLogin: isMobile ? true : false,
          domain: window.location.hostname === "localhost" ? 'taka365.win' : window.location.hostname
        },
        token: cookies.get('skyTokenFront') ? cookies.get('skyTokenFront') : '',
      }

      await postApi(data).then(function (response) {
        window.open(response?.data?.data?.url, '_blank');
      }).catch(err => {
        console.log(err);
        notifyError(err?.response?.data?.message)

        if (err.response.data.statusCode === 401) {
          Logout()
        }
      })
    } else {
      if (fromMobile) { window.location.pathname = '/login' }
      notifyError('please login first')
    }
  };

  if (!shouldShow) return null;

  return (
    <div ref={buttonRef}
      className={`betbtn1 ${position ? "is-dragged" : ""}`}
      style={
        position
          ? {
            left: `${position.x}px`,
            top: `${position.y}px`,
          }
          : {}
      }
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
      onPointerUp={handlePointerUp}>
      <img src="/images/promot.svg" alt="" draggable={false}
        onClick={() => {
          if (!isDragging) {
            getCasinoLink();
          }
        }} />
    </div>
  );
};

export default DraggablePromo;